/** Fade in/out wrapper with configurable timing. Import, never remake. */

import type { ReactNode } from "react";
import { useCurrentFrame, interpolate } from "remotion";

interface FadeTransitionProps {
  children: ReactNode;
  durationInFrames: number;
  fadeIn?: number;
  fadeOut?: number;
}

export function FadeTransition({
  children,
  durationInFrames,
  fadeIn = 10,
  fadeOut = 10,
}: FadeTransitionProps) {
  const frame = useCurrentFrame();

  const opacity = interpolate(
    frame,
    [0, fadeIn, durationInFrames - fadeOut, durationInFrames],
    [0, 1, 1, 0],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" },
  );

  return <div style={{ opacity, width: "100%", height: "100%" }}>{children}</div>;
}
